<template>
    <div>
       <div :class="isMobile?'contBoxB':'contBox'">
           <div class="clearfix">
            <span class="fl mr5" :class="isMobile?'ml10':''">当前位置:</span>
            <el-breadcrumb class="fl" style="margin-top: 4px;font-size: 15px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/notice?type='+type }">{{title}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{title}}详情</el-breadcrumb-item>
            </el-breadcrumb>
           </div>
           <div :class="isMobile?'contentShowB':'contentShow'">
                <p class="contsTitle" style="border: none;">{{info.Title}}</p>
                <p class="sendTime">发布时间:{{info.AddTime | timeToDate}}</p>
                <div class="contSHow" v-html="info.Content"></div>
           </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                id:'',
                type:'',
                info:'',
                title:'',
                typeList:[
                    {
                        title:'通知公告',
                        id:106101
                    },
                    {
                        title:'协会工作',
                        id:106102
                    },
                    {
                        title:'行业动态',
                        id:106103
                    },
                    {
                        title:'会员动态',
                        id:106104
                    },
                    {
                        title:'风采展示',
                        id:106105
                    }
                ]
            }
        },
        methods:{
            getInfo(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataDetail',
                    method: 'get',
                    data:{
                        id:this.id
                    }
                }).then((data) => {
                   this.info = data.Data
                })
            }
        },
        mounted(){
            this.id = this.$route.query.id
            var type = this.$route.query.type
            this.type = type
            this.typeList.forEach(item=>{
                if(item.id==type){
                    this.title = item.title
                }
            })
            this.getInfo()
        }
    }
</script>